import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { Box, Dialog } from "@mui/material";
import DynamicTable from "../../Utils/DynamicTable";
import AddHiringqueue from "./hiringadd";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import {
  getalluserdetailstatus,
  deleteuserstatus,
} from "../shortlisted/mutation";
import { fetchAll, deleteItem, postItem } from "../../../BaseUrl";
import { gellallnotshorlist, getallFilternotshorlist } from "./mutation";
import MessagePopup from "../../Utils/MessagePopup";
import axios from "axios";
import LoadingSpinner from "../../loader/loadercomp";
import ExportDialog from "../../Utils/ExportDialog";
import { UserContext } from "../../usercontext/usercontext";

function Hiringqueue() {
  const { user,isuser } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [view, setview] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userlist, setuserlist] = useState([]);
  const [Loader, setLoader] = useState(false);

  const [countryState, setCountryState] = useState({
    countries: [],
    countryCodes: [],
    states: [],
    selectedCountryCode: null,
    selectedCountry: null,
    selectedState: null,
  });
  const [dialogOpen, setDialogOpen] = useState(false);

  const [roleoptions, setroleoptions] = useState([]);
  const [leaderoptions, setleaderoptions] = useState([]);
  const [clientoptions, setclientoptions] = useState([]);
  const [isview, setisview] = useState(false);

  const columns = [
    { label: "Candidate Name", field: "candidateName" },
    { label: "Interview Date", field: "date" },
    { label: "Status", field: "status" },
    { label: "Created By", field: "createdBy" },
    { label: "Actions", field: "actions" },
  ];

  const validIndustryData = Array.isArray(userlist) ? userlist : [];

  const filteredData =
    searchdata.length > 2
      ? validIndustryData.filter((lesson) => {
          const lowerTerm = searchdata.toLowerCase();
          return Object.entries(lesson).some(
            ([key, value]) =>
              typeof value === "string" &&
              value.toLowerCase().includes(lowerTerm)
          );
        })
      : [];

  const sortedData =
    searchdata.length > 2
      ? filteredData
      : [...validIndustryData].sort((a, b) => {
          const sortOption = sortedvalue?.value || "descending"; // default to descending
          switch (sortOption) {
            case "ascending":
              return new Date(a.createdAt) - new Date(b.createdAt);
            case "descending":
              return new Date(b.createdAt) - new Date(a.createdAt);
            default:
              return validIndustryData; // default to descending
          }
        });

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportData = sortedData.map((item) => ({
    id: item.id,
    candidateName: item.candidateName || "N/A",
    candidateNumber: item.candidateNumber || "N/A",
    positionName: item.position?.positionName || "N/A",
    jobDescription: item.position?.jopDescription || "N/A",
    clientName: item.client?.clientName || "N/A",
    status: item.status || "N/A",
    feedback: item.feedback || "N/A",
    date: formatDate(item.date),
    createdBy: item.createdBy || "N/A",
    createdAt: formatDate(item.createdAt),
    updatedAt: formatDate(item.updatedAt),
    updatedBy: item.updatedBy || "N/A",
  }));

  useEffect(() => {
    getALluserdetail();
  }, []);

  useEffect(() => {
    getALluserdetail();
  }, [open]);

  const formClose = () => {
    setOpen(false);
    getALluserdetail();
    setview(false);
    setisview(false);
  };

  const exportClose = () => {
    setOpenExport(false);
  };

  const addRole = () => {
    setOpen(true);
  };

  const onView = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
    setview(true);
    setisview(true);
  };

  const onEdit = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
    setview(true);
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async (id) => {
    try {
      const variables = {
        input: {
          id: id,
        },
      };
      const response = await deleteItem(deleteuserstatus, variables);
      if (response.deletePosition.success == true) {
        setPopup({
          open: true,
          message: response.deletePosition.message,
          severity: "success",
        });
        deletecancel();
        getALluserdetail();
      } else {
        setPopup({
          open: true,
          message: response.deletePosition.message,
          severity: "error",
        });
        deletecancel();
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  //delete api call
  const deleteRole = async (id) => {
    handleCloseDialog();
  };
  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const getALluserdetail = async () => {
    setLoader(true);
    try {
      const variables = {
        hrUserId: isuser.userid,          
      };
      if (user.roleName === "Admin") {
        const response = await fetchAll(gellallnotshorlist);
        if (response?.getAllScreenings?.success === true) {
          setuserlist(response?.getAllScreenings.screening);
        } else {
          setuserlist([]);
        }
      } else {
        const response = await postItem(getallFilternotshorlist, variables);
        if (response?.getAllScreenings?.success === true) {
          setuserlist(response?.getAllScreenings.screening);
        } else {
          setuserlist([]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      name="Hiring Queue"
    >
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      {Loader && <LoadingSpinner />}
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={exportData}
        fileName="Hiring_Queue"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        {/* <MaterialButton
          variant="contained"
          onClick={() => {
            addRole();
          }}
          sx={{
            background: colors.buttonColor,
            color: "#fff",
            textTransform: "capitalize",
          }}
        >
          + Add Shortlist
        </MaterialButton> */}
        <Dialog
          open={open}
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <AddHiringqueue
            formClose={formClose}
            editeddata={editeddata}
            editedtrue={editedtrue}
            setEditedtrue={setEditedtrue}
            view={view}
            isview={isview}
          />
        </Dialog>
      </Box>
      <DynamicTable
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={deletelist}
        name="Hiring Queue"
      />
    </DashboardLayout>
  );
}

export default Hiringqueue;
